/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { LegalAgreementType } from './';
import {
    LegalAgreementTypeFromJSON,
    LegalAgreementTypeFromJSONTyped,
    LegalAgreementTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface LegalAgreementVersionResource
 */
export interface LegalAgreementVersionResource {
    /**
     * 
     * @type {string}
     * @memberof LegalAgreementVersionResource
     */
    id: string;
    /**
     * 
     * @type {LegalAgreementType}
     * @memberof LegalAgreementVersionResource
     */
    agreementType: LegalAgreementType;
    /**
     * 
     * @type {number}
     * @memberof LegalAgreementVersionResource
     */
    versionNumber: number;
    /**
     * 
     * @type {string}
     * @memberof LegalAgreementVersionResource
     */
    contentChecksum: string;
    /**
     * 
     * @type {Date}
     * @memberof LegalAgreementVersionResource
     */
    publishedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof LegalAgreementVersionResource
     */
    publishedByAccountId: string;
    /**
     * Published immutable contents by language.
     * HTML is stored as authored by Malt admins. User-facing rendering must sanitize or isolate this HTML before injecting it into the DOM.
     * 
     * @type {{ [key: string]: string; }}
     * @memberof LegalAgreementVersionResource
     */
    contents: { [key: string]: string; };
}

/**
 * Check if a given object implements the LegalAgreementVersionResource interface.
 */
export function instanceOfLegalAgreementVersionResource(value: object): value is LegalAgreementVersionResource {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('agreementType' in value) || value['agreementType'] === undefined) return false;
    if (!('versionNumber' in value) || value['versionNumber'] === undefined) return false;
    if (!('contentChecksum' in value) || value['contentChecksum'] === undefined) return false;
    if (!('publishedAt' in value) || value['publishedAt'] === undefined) return false;
    if (!('publishedByAccountId' in value) || value['publishedByAccountId'] === undefined) return false;
    if (!('contents' in value) || value['contents'] === undefined) return false;
    return true;
}

export function LegalAgreementVersionResourceFromJSON(json: any): LegalAgreementVersionResource {
    return LegalAgreementVersionResourceFromJSONTyped(json, false);
}

export function LegalAgreementVersionResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): LegalAgreementVersionResource {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'agreementType': LegalAgreementTypeFromJSON(json['agreementType']),
        'versionNumber': json['versionNumber'],
        'contentChecksum': json['contentChecksum'],
        'publishedAt': (new Date(json['publishedAt'])),
        'publishedByAccountId': json['publishedByAccountId'],
        'contents': json['contents'],
    };
}

export function LegalAgreementVersionResourceToJSON(value?: LegalAgreementVersionResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'agreementType': LegalAgreementTypeToJSON(value['agreementType']),
        'versionNumber': value['versionNumber'],
        'contentChecksum': value['contentChecksum'],
        'publishedAt': ((value['publishedAt']).toISOString()),
        'publishedByAccountId': value['publishedByAccountId'],
        'contents': value['contents'],
    };
}

